var _defs, _rect, _rect2, _path, _rect3, _path2, _circle, _path3, _path4, _path5, _rect4, _rect5, _rect6, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebinar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Category Webinar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c4c5ca;}.cls-2{fill:#6de2e2;}.cls-3{fill:#282d3d;}.cls-4{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17,
    y: 96,
    width: 66,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 1.5,
    width: 69,
    height: 93,
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82,96H18a4,4,0,0,1-4-4V4a4,4,0,0,1,4-4H82a4,4,0,0,1,4,4V92A4,4,0,0,1,82,96ZM18,3a1,1,0,0,0-1,1V92a1,1,0,0,0,1,1H82a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 26.5,
    y: 28.5,
    width: 46,
    height: 31
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74,61H25V27H74ZM28,58H71V30H28Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 66,
    cy: 60,
    r: 7.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66,69a9,9,0,1,1,9-9A9,9,0,0,1,66,69Zm0-15a6,6,0,1,0,6,6A6,6,0,0,0,66,54Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66,67.5h0A18.5,18.5,0,0,1,84.5,86v5.61a2.89,2.89,0,0,1-2.89,2.89H47.5a0,0,0,0,1,0,0V86A18.5,18.5,0,0,1,66,67.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.61,96H46V86a20,20,0,0,1,40,0v5.61A4.4,4.4,0,0,1,81.61,96ZM49,93H81.61A1.39,1.39,0,0,0,83,91.61V86a17,17,0,0,0-34,0Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 39,
    y: 2,
    width: 22,
    height: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 55,
    y: 36,
    width: 11,
    height: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 55,
    y: 43,
    width: 11,
    height: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.5,53a8.5,8.5,0,0,1,0-17H43v7h7v1.5A8.51,8.51,0,0,1,41.5,53ZM40,39.21A5.5,5.5,0,1,0,46.79,46H40Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinar);
export default __webpack_public_path__ + "static/media/webinar.58389462.svg";
export { ForwardRef as ReactComponent };